// extracted by mini-css-extract-plugin
export default {"main":"layout_main__VFd++","noSideBar":"layout_noSideBar__WLijF","navbar":"layout_navbar__j-jcg"};